import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class DropdownService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getData(origen, id): Observable<any> {
    let url = Constants.BASE_URL + origen + "/" + id;
    //alert(url);
    return this.http.get<any>(url).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Formulario",
            text: "Error Cargando la informacion.",
            icon: "error",
          });
        }
        return throwError(err);
      })
    );
  }
}
